module.exports = __webpack_public_path__ + "static/img/Download-active.6c43f831.svg";